import { deleteRequest, get, post} from './_defaults/fetch.js';

export const getPermissions = ({params, config}) => get('/permissions', {params, ...config});
export const getPermission = ({id, params, config}) => get(`/permissions/${id}`, {params, ...config});
export const createPermission = ({data, config}) => post('/permissions', data, config);
export const updatePermission = ({id, data, config}) => post(`/permissions/${id}`, data, config);
export const deletePermission = ({id, config}) => deleteRequest(`/permissions/${id}`, null, config);

